import { useTranslation } from 'react-i18next';
import { Investment, TtDetails } from '../../generated/graphql';
import { AmountTable, AmountTableProps } from './Table';

export interface InvestmentsTableContainerProps
  extends Pick<
    AmountTableProps,
    'title' | 'className' | 'hideOnEmpty' | 'isLoading' | 'tableRowsContainerClassName' | 'tableTitleClassName'
  > {
  onItemClicked?: (a: { investment: Investment }) => void;
  investmentArray?: Investment[];
  investmentsSubset?: keyof Pick<TtDetails['assetSummary'], 'afterTaxInvestments' | 'preTaxInvestments'>;
  children?: (p: { investment: Investment }) => React.ReactNode;
}

export const InvestmentsTableContainer = ({
  investmentsSubset,
  children,
  onItemClicked,
  investmentArray,
  ...props
}: InvestmentsTableContainerProps) => {
  const { t: tCommon } = useTranslation('common');

  return (
    <AmountTable
      hideOnEmpty={props.hideOnEmpty ?? true}
      title={
        props.title ??
        (investmentsSubset === 'afterTaxInvestments'
          ? tCommon('after-tax-investments')
          : tCommon('pre-tax-investments'))
      }
      {...props}
    >
      {investmentArray?.sort((a, b) => a.name.localeCompare(b.name)).map((investment) => children?.({ investment }))}
    </AmountTable>
  );
};
